<template>
  <div class="viq-page">
    <div class="viq-page__container container">
      <ViqSidebar />
      <div class="viq-page__main" :style="mainStyle">
        <div class="viq-page__content">
          <ViqSubscriptionBar />
          <ViqLensIndicator v-if="activeLens" />
          <template v-if="!activeConversation && !isReportMode">
            <ViqWelcome>
              <ViqInputArea v-if="showInput" slot="input" />
            </ViqWelcome>
          </template>
          <template v-else-if="isReportMode && !activeConversation">
            <ViqReportPanel />
          </template>
          <template v-else>
            <ViqChatPanel v-if="isAskMode" />
            <ViqReportPanel v-else />
          </template>
        </div>
        <ViqInputArea v-if="showInput && (activeConversation || isReportMode)" />
      </div>
    </div>
    <ViqSlideOut />
    <ViqShareDialog />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ViqPage",
  components: {
    ViqSidebar: () => import("./ViqSidebar"),
    ViqSubscriptionBar: () => import("./ViqSubscriptionBar"),
    ViqLensIndicator: () => import("./ViqLensIndicator"),
    ViqWelcome: () => import("./ViqWelcome"),
    ViqChatPanel: () => import("./ViqChatPanel"),
    ViqReportPanel: () => import("./ViqReportPanel"),
    ViqInputArea: () => import("./ViqInputArea"),
    ViqSlideOut: () => import("./ViqSlideOut"),
    ViqShareDialog: () => import("./ViqShareDialog"),
  },
  computed: {
    ...mapState("Viq", [
      "sidebarCollapsed",
      "activeConversation",
      "activeLens",
      "mode",
      "reportType",
      "reportStep",
    ]),
    ...mapGetters("Viq", ["isReportMode", "isAskMode"]),
    showInput() {
      if (this.mode === "lens-build") return false;
      if (this.isAskMode) return true;
      if (this.isReportMode && this.reportStep <= 1) return true;
      return false;
    },
    mainStyle() {
      return { marginLeft: "0" };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/helpers/variables";
@import "@/assets/styles/viq.scss";

.viq-page {
  flex: 1;
  min-height: 0;
  background: rgb(249, 250, 251);

  &__container {
    position: relative;
    display: flex;
    min-height: calc(100vh - 10rem);
    padding-top: 145px;
    padding-bottom: $viq-space-md;
  }

  &__main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    transition: margin-left 250ms ease;
  }

  &__content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: $viq-space-lg $viq-space-xl;
    width: 100%;

    > * {
      width: 90%;
      max-width: 100%;
    }
  }
}
</style>
